import { gql } from "@apollo/client";

export const REFUND_BOOKING = gql`
    mutation refundBooking($booking_id: Int!) {
        refundBooking(booking_id: $booking_id)
    }
`;

export const CANCEL_BOOKING = gql`
    mutation cancelBooking($booking_id: Int!, $reason_id: Int!, $state: String!) {
        cancelBooking(booking_id: $booking_id, reason_id: $reason_id, state: $state)
    }
`;

export const ACCEPT_BOOKING = gql`
    mutation acceptBooking($booking_id: Int!) {
        acceptBooking(booking_id: $booking_id)
    }
`;

export const COMPLETED_BOOKING = gql`
    mutation completeBooking($booking_id: Int!) {
        completeBooking(booking_id: $booking_id)
    }
`;

export const UPDATE_STATUS_BOOKING = gql`
    mutation updateStatusBooking($booking_id: Int!, $state: String!) {
        updateStatusBooking(booking_id: $booking_id, state: $state)
    }
`;

export const CREATE_BOOKING = gql`
    mutation createBooking($data: CreateBookingInput!) {
        createBooking(data: $data) {
            id
        }
    }
`;

export const EVALUATION_BOOKING = gql`
    mutation evaluationBooking($data: EvaluationBookingInput!) {
        evalutionBooking(data: $data)
    }
`;

export default REFUND_BOOKING;